import React from 'react';
import Title from 'components/UI/Title';
import Hint from 'components/UI/Hint';
import CounterBox from 'components/UI/CounterBox';
import * as styles from './Desktop.module.scss';

function CounterDesktop({
  name,
  hint,
  value,
  increment,
  decrement,
  sectionIndex,
  columnIndex,
  counterIndex,
}) {
  const labelId = `counter-desktop-label-${sectionIndex}-${columnIndex}-${counterIndex}`;

  return (
    <>
      <CounterBox
        value={value}
        increment={() => {
          increment(name, value);
        }}
        decrement={() => {
          decrement(name, value);
        }}
        labelId={labelId}
      />
      <Title tag="h4" size={false} className={styles.title}>
        <span id={labelId}>{name}</span>
        {hint && (
          <span className={styles.hint}>
            <Hint withIcon showOnlyOne content={hint} zIndex={100} />
          </span>
        )}
      </Title>
    </>
  );
}

export default React.memo(CounterDesktop);
